enum ExpectedAnswerType {
    Boolean = 'Boolean',
    DateTime = 'DateTime',
    Numeric = 'Numeric',
    SelectedChoice = 'SelectedChoice',
    Text = 'Text',
}

export default ExpectedAnswerType;
